import controller from './categories-slider-filter.controller';
import template from './categories-slider-filter.view.html';

let CategoriesSliderFilterComponent = {
  template,
  controller,
  bindings : {
    shCtrl : '<'
  }
};

export default CategoriesSliderFilterComponent;



/** WEBPACK FOOTER **
 ** C:/xampp/htdocs/payomaro-pay-zone/www/components/catalog/categories-filter/categories-slider-filter/categories-slider-filter.component.js
 **/